import React, { FC, ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { localizeType } from '../../commonType';
import { setOpenDateSelector } from '../../features/offerAvailability/offerAvailabilitySlice';
import { RootState } from '../../redux/rootReducer';
import withLocalization from '../hoc/withLocalization';
import './DatePriceSelector.scss';
interface DatePriceSelectorProps {
  localize: localizeType;
  onNavigateToEligibility: (n: boolean) => void;
}

const DatePriceSelector: FC<DatePriceSelectorProps> = (props: DatePriceSelectorProps): ReactElement => {
  const selectedDate = useSelector((state: RootState) => state.availabilityDates?.selectedDate);
  const { localize, onNavigateToEligibility } = props;
  const isDisabled: boolean = selectedDate !== undefined;

  const dispatch = useDispatch();

  const onCheckInClick = (evt) => {
    dispatch(setOpenDateSelector(false));
    onNavigateToEligibility(true);
  };
  const onChooseLaterClick = (evt) => {
    dispatch(setOpenDateSelector(true));
    onNavigateToEligibility(false);
  };

  return (
    <>
      <div className="container checkinWrapper">
        <div>
          <button className="checkInButton palmBg upperCase" onClick={onCheckInClick} disabled={!isDisabled}>
            {localize('preview-sales-engine.static-content.copy.calendar-page.select-check-in-date-button')}
          </button>

          <button className="chooseLater" onClick={onChooseLaterClick}>
            {localize('preview-sales-engine.static-content.copy.calendar-page.choose-dates-later-button')}
          </button>
        </div>
      </div>
    </>
  );
};

export default withLocalization(DatePriceSelector);
